<div >
     <div class="container-fluid">
          <div class="row" >
            <div class="col-md-12" class="break-msg">
              <p-messages   class="break-msg" class="aetna-msg" [(value)] ="msgs" [closable]="false"></p-messages>
            </div> 
          </div> 
          <div class="row" >
              <div class="col-md-5"></div>
              <div class="col-md-2">
                  <p-progressSpinner *ngIf="showSpiner" [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
              </div>
              <div class="col-md-5"></div>
            </div>   
      </div>

      <p-panel *ngIf="showDivforUnsub">
          <p-header>
            <div class="ui-helper-clearfix">
              <h2> 
                <span class="ui-panel-title" style="font-size: 22px;display:inline-block;margin-top:2px;font-weight: 500;">{{appName}}</span> 
                <span *ngIf="pathInfo=='production'" class="badge badge-pill badge-primary">{{pathInfo}}</span>
               
                <span *ngIf="pathInfo=='sandbox'" class="badge badge-pill badge-secondary">{{pathInfo}}</span>
             
              </h2>    
              
             
            </div>
        </p-header>
        <div *ngIf="showGrid"   style="background-color:#f5f5f5;width:100%" class="mx-auto d-block"> 
            <p-table #dt *ngIf="showGrid" [columns]="subCols" [value]="subscriptionForAnApp" [style]="{width: '100%'}"  [responsive]="true"  [rows]="7">
              <ng-template pTemplate="header" let-columns>
                  <tr>
                      <th style="width: 30%;">Product Name                 
                      
                      </th>
                      <th style="width: 10%;">Version</th>
                   <!--
                      <th style="width: 12%;">Plan</th>
                      -->
                      <th style="width: 10%;">Status</th>
                    
                      <th style="width: 10%;">APIs</th>
                      <th style="width: 20%;">Unsubscribe</th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr>
                    <td class="text-break">
                      {{rowData['productName']}}
                  </td>
                      <td class="text-break">
                        {{rowData['productVersion']}}
                    </td>
                       <!--
                    <td class="text-break">
                        {{rowData['plan']}}
                    </td>
                  -->
                    <td class="text-break">
                  
                        <span [class]="'customer-badge status-' + rowData['cssname']">{{rowData['nonProdStatus']}}</span>
                    </td>
                  
                    
                      <td > <button pButton (click)="viewApisForSubscription(rowData)"  class="aetna-button ui-button-raised ui-button-rounded" label="View"> </button></td> 
                      <td > <button pButton (click)="unsubscriptionConfirmation(rowData)"  class="aetna-button ui-button-raised ui-button-rounded" label="Unsubscribe"> </button></td>
                    </tr>
              </ng-template>
          </p-table>
        </div>
        <div *ngIf="showNoSubData">
          <p>No Subscription Data Available.</p>
        </div>
      </p-panel>
      <br>

      <p-table #dt  *ngIf="apisViewEnable" [columns]="apisPlanCols" [value]="apisView" [style]="{width: '100%'}"  [responsive]="true" [scrollable]="true" scrollHeight="280px"  [rows]="5">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th>
                  <label for="api"> APIs</label>
                  <input  id="api"  pInputText type="text"
                          (input)="dt.filter($event.target.value, 'path', 'contains')" placeholder="Search"/>
                
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr *ngIf="!(rowData.path=='fhir-server-pkce-api-provider' || rowData.path=='fhir-mobile-pkce-api-provider')  ">
              <td class="text-break">
                {{rowData['path']}}
            </td>
              
                
            </tr>
        </ng-template>
      </p-table>


      
      <p-dialog [modal]="true" header="Unsubscribe Plan" [closable]="false" [(visible)]="unsubsribeconfirmationPopup" [style]="{width: '50vw'}" [baseZIndex]="10000">
        
        <label class="font-weight-bold"> Do you want to unsubscribe this plan?</label>
      <p-footer>
        <button type="button" pButton icon="pi pi-check" (click)="unSubscriptionForAnApp()" label="Yes"class="aetna-button ui-button-raised ui-button-rounded" ></button>
        <button type="button"  pButton icon="pi pi-times" (click)="unsubscriptioncancelConfirmation()" label="No" class="aetna-button ui-button-raised ui-button-rounded"></button>
      </p-footer>
      </p-dialog>

</div>